import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BookingInterface from './BookingInterface';
import { useAuth } from "../../hooks/useSupabaseAuth"

const BookingPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, isLoading, client } = useAuth();
  const [loading, setLoading] = useState(true);
  const [clientData, setClientData] = useState<any>(null);
  
  // Get session type from URL parameter
  const sessionTypeParam = searchParams.get('sessionType');

  useEffect(() => {
    // Use client data from auth hook
    if (!isLoading) {
      setLoading(false);
      if (client) {
        setClientData(client);
      }
    }
  }, [isLoading, client]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-stone-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-green-600 mx-auto"></div>
          <p className="mt-4 text-brand-stone-600">Verifying access...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-stone-100">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-brand-green-800 mb-4">
            Authentication Required
          </h1>
          <p className="text-brand-stone-600 mb-4">
            You must be logged in to book an appointment. Please access this page through your client portal.
          </p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-2 bg-brand-green-600 text-white rounded-lg hover:bg-brand-green-700 transition-colors"
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }
  
  const handleBookingComplete = (bookingId: string) => {
    console.log('Booking completed:', bookingId);
    // Optionally redirect to client portal
    navigate(`/client/portal`);
  };
  
  return (
    <div className="min-h-screen bg-brand-stone-100">
      <BookingInterface 
        sessionType={sessionTypeParam}
        onBookingComplete={handleBookingComplete}
        clientData={clientData}
        defaultSessionType="individual"
      />
    </div>
  );
};

export default BookingPage;